// semeia-disable-reexport

import Performer from "cnam/models/performer";
import Prescriptor from "cnam/models/prescriptor";
import ReimbursementsRetrievedJournalEvent from "cnam/models/reimbursements-retrieved-journal-event";
import Specialty from "cnam/models/specialty";
import { dayDiffBetweenDates, hoursDiffBetweenDates } from "core/utils/time";
import { getLastJeOfClass } from "core/utils/journal-events";
export function hasNoReimbursementSinceYesterday(patient) {
  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  yesterday.setHours(0, 0, 0, 0);
  const latestReimbursementJE = getLastJeOfClass(patient.activeJournalEvents, ReimbursementsRetrievedJournalEvent);
  return !latestReimbursementJE || latestReimbursementJE?.occurredAt < yesterday;
}
function dmpRetrievalStartedJesPerCpsId(jes, cpsId) {
  return jes.filter(je => je.cpsId === cpsId);
}
export function numberTriesForCurrentHourPerCpsId(jes, cpsId) {
  return dmpRetrievalStartedJesPerCpsId(jes, cpsId).filter(je => hoursDiffBetweenDates(new Date(), je.occurredAt) == 0).length;
}
export function numberTriesForLastHourPerCpsId(jes, cpsId) {
  return dmpRetrievalStartedJesPerCpsId(jes, cpsId).filter(je => hoursDiffBetweenDates(new Date(), je.occurredAt) < 1).length;
}
export function numberTriesForLastDayPerCpsId(jes, cpsId) {
  return dmpRetrievalStartedJesPerCpsId(jes, cpsId).filter(je => dayDiffBetweenDates(new Date(), je.occurredAt) == 0).length;
}
export function numberTriesForLastTwentyFourHoursPerCpsId(jes, cpsId) {
  return dmpRetrievalStartedJesPerCpsId(jes, cpsId).filter(je => hoursDiffBetweenDates(new Date(), je.occurredAt) < 24).length;
}
export function prescriptorRetrieve(authorObject) {
  const assignedPerson = authorObject?.assignedAuthor?.assignedPerson?.name;
  let firstName;
  let lastName;
  if (assignedPerson) {
    firstName = assignedPerson?.given?._text;
    lastName = assignedPerson?.family?._text;
  }
  const assignedAuthor = authorObject?.assignedAuthor;
  let identifier;
  if (assignedAuthor?.id?._attributes?.root == "1.2.250.1.71.4.2.1") {
    identifier = assignedAuthor?.id._attributes.extension;
  }
  const code = assignedAuthor?.code?._attributes;
  const specialty = new Specialty({
    codeSystemName: code?.codeSystemName,
    codeSystem: code?.codeSystem,
    code: code?.code,
    displayName: code?.displayName
  });
  return new Prescriptor({
    firstName,
    lastName,
    identifier,
    specialty
  });
}
export function performerRetrieve(performerObject) {
  const assignedPerson = performerObject?.assignedEntity?.assignedPerson?.name;
  let firstName;
  let lastName;
  if (assignedPerson) {
    firstName = assignedPerson?.given?._text;
    lastName = assignedPerson?.family?._text;
  }
  const code = performerObject?.assignedEntity?.code?._attributes;
  const specialty = new Specialty({
    codeSystemName: code?.codeSystemName,
    codeSystem: code?.codeSystem,
    code: code?.code,
    displayName: code?.displayName
  });
  const representedOrganization = performerObject?.assignedEntity?.representedOrganization;
  const organizationName = representedOrganization?.name?._text;
  let organizationIdentifier;
  if (representedOrganization?.id?._attributes?.root == "1.2.250.1.71.4.2.2") {
    organizationIdentifier = representedOrganization?.id?._attributes?.extension;
  }
  return new Performer({
    name: {
      firstName,
      lastName
    },
    specialty,
    organization: {
      name: organizationName,
      identifier: organizationIdentifier
    }
  });
}